import { CatalogType } from "../../types";
import { axiosInstance } from "./axiosInstance";

export class CatalogService {
    async getCatalogData(catalog: CatalogType) {
        const response = await axiosInstance.get(`/catalog/${catalog}`);
        return response;
    }
}